import {refreshAccessToken} from '@dms/api/base';

import {applyRefreshResult} from './applyRefreshResult';
import {detachSocket} from './detachSocket';
import type {SocketContext, SubscriptionDeps, SubscriptionState} from './subscriptionTypes';

/**
 * Kicks off the auth-refresh self-heal: detach + close THIS socket, refresh
 * the token, then either open a successor (success) or stop the loop
 * (failure / breaker trip).
 *
 * Ordering is load-bearing:
 *   1. Mark `isRefreshing` so concurrent auth errors and onclose handlers no-op.
 *   2. Cancel any pending reconnect so it cannot fire alongside the successor.
 *   3. Detach handlers BEFORE close so the browser-delivered onclose for this
 *      socket cannot schedule a stray reconnect after the refresh resolves.
 */
export const startAuthRefresh = (
  state: SubscriptionState,
  deps: SubscriptionDeps,
  ctx: SocketContext
) => {
  state.isRefreshing = true;

  clearTimeout(state.reconnectTimer);
  state.reconnectTimer = undefined;

  detachSocket(ctx);
  ctx.socket.close();

  void refreshAccessToken(deps.dispatch, deps.getState)
    .then((refreshed) => applyRefreshResult(refreshed, state))
    .catch(() => {
      state.isRefreshing = false;
      state.hasStopped = true;
    });
};
